import React, { useEffect, useState } from "react";
import { Container, Table } from "react-bootstrap";
import viewaction from "../../assets/images/viewaction.svg";
import Accordion from "react-bootstrap/Accordion";
import { useDispatch, useSelector } from "react-redux";
import { GetAllContractList } from "../../services/ReduxTookit/Slice/DigiSignRedux";
import { commonservices } from "../../services/CommonServices";
import Skeleton from "react-loading-skeleton";
import Loader, { LoaderType } from "../../component/common-component/Loader";
import addIcon from "../../assets/images/addSm.svg";
import minusIcon from "../../assets/images/minusIcon.svg";
import PDFViewModel from "../../component/common-component/PDFViewModel";
const LegalManagementModel = () => {
  const [expandedRow, setExpandedRow] = useState(null);

  const dispatch = useDispatch();
  let DevRoute = window.location.href.includes(`${process.env.REACT_APP_DEV}`);
  const LegalData = useSelector(
    (state) => state?.digisignredux?.GetAllContractListData?.data?.data?.data
  );

  const [pdfViewModel, setPdfViewModel] = useState(false);

  const [Loading, setLoading] = useState(false);
  useEffect(() => {
    setLoading(true);
    dispatch(GetAllContractList(DevRoute ? "Developer" : "DataFactory")).then(
      (res) => {
        setLoading(false);
      }
    );
  }, [DevRoute]);

  const groupedData = LegalData?.reduce((acc, item) => {
    if (item?.type === "Machine Contract") {
      if (!acc[item.sellername]) {
        acc[item.sellername] = [];
      }
      acc[item.sellername].push(item);
    }
    return acc;
  }, {});

  const groupedDataDeveloper = LegalData?.reduce((acc, item) => {
    if (item?.type === "Machine Contract") {
      if (!acc[item.machinename]) {
        acc[item.machinename] = [];
      }
      acc[item.machinename].push(item);
    }
    return acc;
  }, {});

  const handleShowCollapse = (rowId) => {
    setExpandedRow(expandedRow === rowId ? null : rowId);
  };

  return (
    <>
      {" "}
      {/* {Loading ? (
        <>
          <Skeleton height={45} width={"100%"} />
          <Skeleton height={45} width={"100%"} />
          <Skeleton height={45} width={"100%"} />
        </>
      ) : ( */}
      <>
        {/* <Accordion className="profile-legal-accordion">
            {LegalData?.filter((item) => item?.type === "Contract")?.map(
              (item, index) => {
                return (
                  <Accordion.Item eventKey={index + "Client"}>
                    <Accordion.Header>{item?.type}</Accordion.Header>
                    <Accordion.Body>
                      <div className="table-wrapper-main">
                        <Table responsive>
                          <thead>
                            <tr>
                              <th className="width400">Name</th>
                              <th>Date</th>
                              <th className="sticky-actions text-end">
                                Action
                              </th>
                            </tr>
                          </thead>

                          <tbody>
                            <tr>
                              <td className="theme-color-text fw-bold">
                                {item?.machinename}
                              </td>
                              <td>
                                {" "}
                                {item?.createddate
                                  ? commonservices.convertTimeToLocal(
                                      item?.createddate
                                    )
                                  : ""}{" "}
                                {item?.createddate
                                  ? commonservices.convertDateToLocal(
                                      item?.createddate
                                    )
                                  : ""}
                              </td>

                              <td className="sticky-actions">
                                <div className="all-actions">
                                  <img
                                    src={viewaction}
                                    alt="viewaction"
                                    onClick={() => {
                                      window.open(item?.contracturl, "_blank");
                                    }}
                                  />
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </Table>
                      </div>
                    </Accordion.Body>
                  </Accordion.Item>
                );
              }
            )}

            {!DevRoute &&
              groupedData &&
              Object.entries(groupedData).map(
                ([sellername, contracts], index) => (
                  <Accordion.Item eventKey={index.toString()} key={index}>
                    <Accordion.Header>{sellername}</Accordion.Header>
                    <Accordion.Body>
                   
                      <div className="table-wrapper-main">
                        <Table responsive>
                          <thead>
                            <tr>
                              <th className="width400">Name</th>
                              <th>Date</th>
                              <th className="sticky-actions text-end">
                                Action
                              </th>
                            </tr>
                          </thead>

                          <tbody>
                            {contracts.map((contract, idx) => (
                              <tr>
                                <td className="theme-color-text fw-bold">
                                  {contract?.machinename}
                                </td>
                                <td>
                                  {" "}
                                  {contract?.createddate
                                    ? commonservices.convertTimeToLocal(
                                        contract?.createddate
                                      )
                                    : ""}{" "}
                                  {contract?.createddate
                                    ? commonservices.convertDateToLocal(
                                        contract?.createddate
                                      )
                                    : ""}
                                </td>

                                <td className="sticky-actions">
                                  <div className="all-actions">
                                    <img
                                      src={viewaction}
                                      alt="viewaction"
                                      onClick={() => {
                                        window.open(
                                          contract?.contracturl,
                                          "_blank"
                                        );
                                      }}
                                    />
                                  </div>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </Table>
                      </div>
                    </Accordion.Body>
                  </Accordion.Item>
                )
              )}
            {DevRoute &&
              groupedDataDeveloper &&
              Object.entries(groupedDataDeveloper).map(
                ([sellername, contracts], index) => (
                  <Accordion.Item eventKey={index.toString()} key={index}>
                    <Accordion.Header>{sellername}</Accordion.Header>
                    <Accordion.Body>
                     
                      <div className="table-wrapper-main">
                        <Table responsive>
                          <thead>
                            <tr>
                              <th className="width400">Name</th>
                              <th>Date</th>
                              <th className="sticky-actions text-end">
                                Action
                              </th>
                            </tr>
                          </thead>

                          <tbody>
                            {contracts.map((contract, idx) => (
                              <tr key={idx}>
                                <td className="theme-color-text fw-bold">
                                  {contract?.buyername}
                                </td>
                                <td>
                                  {" "}
                                  {contract?.createddate
                                    ? commonservices.convertTimeToLocal(
                                        contract?.createddate
                                      )
                                    : ""}{" "}
                                  {contract?.createddate
                                    ? commonservices.convertDateToLocal(
                                        contract?.createddate
                                      )
                                    : ""}
                                </td>

                                <td className="sticky-actions">
                                  <div className="all-actions">
                                    <img
                                      src={viewaction}
                                      alt="viewaction"
                                      onClick={() => {
                                        window.open(
                                          contract?.contracturl,
                                          "_blank"
                                        );
                                      }}
                                    />
                                  </div>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </Table>
                      </div>
                    </Accordion.Body>
                  </Accordion.Item>
                )
              )}
          </Accordion> */}
        <div className="main-page-content legal-main">          
            <div className="table-wrapper-main">
              <Table responsive>
                <thead>
                  <tr>
                    <th className="width400">Name</th>
                    <th>Date</th>
                    <th className="sticky-actions text-end">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {Loading ? (
                    <Loader type={LoaderType.TableRow} count={4} nooftd={3} />
                  ) : (
                    <>
                      {LegalData?.filter(
                        (item) => item?.type === "Contract"
                      )?.map((item, index) => {
                        const isExpanded = expandedRow === index + "Contract";
                        return (
                          <React.Fragment key={index + "Contract"}>
                            <tr className="dark-bg">
                              <td>
                                <div className="d-flex align-items-center gap-2">
                                  {item?.workflowschedulelogid !== 0 ? (
                                    <>
                                      <img
                                        // src={minusIcon}
                                        src={isExpanded ? minusIcon : addIcon}
                                        alt="toggleIcon"
                                        className="cursor-pointer"
                                        onClick={() =>
                                          handleShowCollapse(index + "Contract")
                                        }
                                      />
                                      <span>{item?.type}</span>
                                    </>
                                  ) : (
                                    "-"
                                  )}
                                </div>
                              </td>
                              <td></td>
                              <td></td>
                            </tr>
                            {isExpanded &&
                              LegalData?.filter(
                                (item) => item?.type === "Contract"
                              )?.map((item_2, index_2) => (
                                <tr>
                                  <td className="theme-color-text fw-bold">
                                    {item_2?.machinename}
                                  </td>
                                  <td>
                                    {" "}
                                    {item_2?.createddate
                                      ? commonservices.convertTimeToLocal(
                                          item_2?.createddate
                                        )
                                      : ""}{" "}
                                    {item_2?.createddate
                                      ? commonservices.convertDateToLocal(
                                          item_2?.createddate
                                        )
                                      : ""}
                                  </td>

                                  <td className="sticky-actions">
                                    <div className="all-actions">
                                      <img
                                        src={viewaction}
                                        alt="viewaction"
                                        onClick={() => {
                                          setPdfViewModel(item_2);
                                          // window.open(
                                          //   item_2?.contracturl,
                                          //   "_blank"
                                          // );
                                        }}
                                      />
                                    </div>
                                  </td>
                                </tr>
                              ))}
                          </React.Fragment>
                        );
                      })}

                      {!DevRoute &&
                        groupedData &&
                        Object.entries(groupedData).map(
                          ([sellername, contracts], index) => {
                            const isExpanded = expandedRow === index + "Seller";
                            return (
                              <React.Fragment key={index + "Seller"}>
                                <tr className="dark-bg">
                                  <td>
                                    <div className="d-flex align-items-center gap-2">
                                      <>
                                        <img
                                          // src={minusIcon}
                                          src={isExpanded ? minusIcon : addIcon}
                                          alt="toggleIcon"
                                          className="cursor-pointer"
                                          onClick={() =>
                                            handleShowCollapse(index + "Seller")
                                          }
                                        />
                                        <span>{sellername}</span>
                                      </>
                                    </div>
                                  </td>
                                  <td></td>
                                  <td></td>
                                </tr>
                                {isExpanded &&
                                  contracts.map((contract, idx) => (
                                    <tr>
                                      <td className="theme-color-text fw-bold">
                                        {contract?.machinename}
                                      </td>
                                      <td>
                                        {" "}
                                        {contract?.createddate
                                          ? commonservices.convertTimeToLocal(
                                              contract?.createddate
                                            )
                                          : ""}{" "}
                                        {contract?.createddate
                                          ? commonservices.convertDateToLocal(
                                              contract?.createddate
                                            )
                                          : ""}
                                      </td>

                                      <td className="sticky-actions">
                                        <div className="all-actions">
                                          <img
                                            src={viewaction}
                                            alt="viewaction"
                                            onClick={() => {
                                              setPdfViewModel(contract);

                                              // window.open(
                                              //   contract?.contracturl,
                                              //   "_blank"
                                              // );
                                            }}
                                          />
                                        </div>
                                      </td>
                                    </tr>
                                  ))}
                              </React.Fragment>
                            );
                          }
                        )}
                      {DevRoute &&
                        groupedDataDeveloper &&
                        Object.entries(groupedDataDeveloper).map(
                          ([sellername, contracts], index) => {
                            const isExpanded =
                              expandedRow === index + "Machine";
                            return (
                              <React.Fragment key={index + "Machine"}>
                                <tr className="dark-bg">
                                  <td>
                                    <div className="d-flex align-items-center gap-2">
                                      <>
                                        <img
                                          // src={minusIcon}
                                          src={isExpanded ? minusIcon : addIcon}
                                          alt="toggleIcon"
                                          className="cursor-pointer"
                                          onClick={() =>
                                            handleShowCollapse(
                                              index + "Machine"
                                            )
                                          }
                                        />
                                        <span>{sellername}</span>
                                      </>
                                    </div>
                                  </td>
                                  <td></td>
                                  <td></td>
                                </tr>
                                {isExpanded &&
                                  contracts.map((contract, idx) => (
                                    <tr>
                                      <td className="theme-color-text fw-bold">
                                        {contract?.buyername}
                                      </td>
                                      <td>
                                        {" "}
                                        {contract?.createddate
                                          ? commonservices.convertTimeToLocal(
                                              contract?.createddate
                                            )
                                          : ""}{" "}
                                        {contract?.createddate
                                          ? commonservices.convertDateToLocal(
                                              contract?.createddate
                                            )
                                          : ""}
                                      </td>

                                      <td className="sticky-actions">
                                        <div className="all-actions">
                                          <img
                                            src={viewaction}
                                            alt="viewaction"
                                            onClick={() => {
                                              setPdfViewModel(contract);

                                              // window.open(
                                              //   contract?.contracturl,
                                              //   "_blank"
                                              // );
                                            }}
                                          />
                                        </div>
                                      </td>
                                    </tr>
                                  ))}
                              </React.Fragment>
                            );
                          }
                        )}
                    </>
                  )}
                </tbody>
              </Table>
            </div>          
        </div>
      </>
      {pdfViewModel && (
        <PDFViewModel
          show={pdfViewModel}
          onHide={(e) => setPdfViewModel(false)}
          // data={pdfViewModel}
        />
      )}
    </>
  );
};

export default LegalManagementModel;
